module.exports = __webpack_public_path__ + "assets/img/content-bg.cbcca7f0.png";